import React from 'react'
import Field from '../../common/FormField'
import { errorClassName } from '../../../utils/form'

export default ({
  data,
  isBasicRetailer,
  error = {},
  onChangeFactory,
  disabled
}) =>
  <fieldset>
    <Field name="Phone Number" error={error.phone}>
      <div className="row">
        <div className="col col-2">
          <label className={`input ${errorClassName(error.countryCode)}`}>
            <input
              type="text"
              placeholder="+1"
              value={data.countryCode}
              onChange={onChangeFactory('countryCode')}
              disabled={disabled}
            />
          </label>
          <label className="note">Country Code</label>
        </div>
        <div className="col col-10">
          <label className={`input ${errorClassName(error.phone)}`}>
            <input
              type="text"
              placeholder="Enter your phone number (i.e. 123-123-1234)"
              value={data.phone}
              onChange={onChangeFactory('phone')}
              disabled={disabled}
            />
          </label>
          <label className="note">Phone</label>
        </div>
      </div>
    </Field>
    <Field
      type="input"
      name="Email *"
      note="You must visit your Account Settings to change your email."
      error={error.email}
    >
      <input
        type="text"
        placeholder="Enter the email address (i.e. johndoe@emailhost.com)"
        value={data.email}
        onChange={onChangeFactory('email')}
        disabled={disabled}
      />
    </Field>
    {isBasicRetailer
      ? null
      : <Field name="Public Contact Preferences">
          <div className="row">
            <div className="col col-3">
              <label className="radio">
                <input
                  type="radio"
                  name="contactGroup"
                  value="phone,email"
                  checked={data.contactDetails === 'phone,email'}
                  onChange={onChangeFactory('contactDetails')}
                  disabled={disabled}
                />
                <i />Both Phone & Email
              </label>
            </div>
            <div className="col col-3">
              <label className="radio">
                <input
                  type="radio"
                  name="contactGroup"
                  value="phone"
                  checked={data.contactDetails === 'phone'}
                  onChange={onChangeFactory('contactDetails')}
                  disabled={disabled}
                />
                <i />Phone Only
              </label>
            </div>
            <div className="col col-3">
              <label className="radio">
                <input
                  type="radio"
                  name="contactGroup"
                  value="email"
                  checked={data.contactDetails === 'email'}
                  onChange={onChangeFactory('contactDetails')}
                  disabled={disabled}
                />
                <i />Email Only
              </label>
            </div>
          </div>
        </Field>}
  </fieldset>
